const defaultFormInputEditingAttributes = {
  optional: {
    description: "Select if this input is optional or no",
    values: [
      { value: "yes", title: "Yes" },
      { value: "no", title: "No" },
    ],
  },
  label: {
    title: "Label for input",
  },
  csvColumnName: {
    title: "Name of the CSV column",
  },
};

const defaultFormInputEditingProperties = [
  "label",
  "optional",
  "csvColumnName",
];

const defaultFormInputInitialContent = {
  optional: "no",
};

export {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
};
